import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDiary } from '../../../models/diary';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { AsyncPipe, NgIf } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { User, UserHeader } from '../../../models/user';
import { UserService } from '../../../services/user.service';
import { instanceToInstance } from 'class-transformer';
import { UserState } from '../../../state/user/user-state';
import { Store } from '@ngxs/store';
import { combineLatest, from, Observable, take } from 'rxjs';

@Component({
  selector: 'app-diary-editor',
  standalone: true,
  imports: [EditorModule, InputTextModule, FloatLabelModule, FormsModule, 
            NgIf, ButtonModule,ButtonGroupModule,DropdownModule,CalendarModule, AsyncPipe,
            FloatLabelModule],
  templateUrl: './diary-editor.component.html',
  styleUrl: './diary-editor.component.scss'
})
export class DiaryEditorComponent implements OnInit
{
  @Input() diary : IDiary = {} as IDiary;
  @Output() saved : EventEmitter<IDiary> = new EventEmitter<IDiary>();
  @Output() cancelled : EventEmitter<void> = new EventEmitter<void>();

  currentUser$: Observable<User|undefined> = this._store.select(UserState.currentUser); 
  activeUsers$: Promise<UserHeader[]> = this._user.getActiveUsers();
  defaultUser?: UserHeader = undefined;

  constructor(private _user : UserService,
    private _store : Store
  )
  {
  }

ngOnInit(): void {
  combineLatest([this.currentUser$, from(this.activeUsers$)])
    .pipe(take(1))
    .subscribe(([currentUser, activeUsers]) => {
      if (!currentUser) return;
      this.defaultUser = activeUsers.find(u => u.id === currentUser.id) ?? UserHeader.fromUser(currentUser);
      if (!this.diary.assignedTo) {
        this.diary.assignedTo = this.defaultUser;
      }
    });
}

  saveButtonPressed(event: MouseEvent)
  {
    this.saved.emit(instanceToInstance(this.diary));
    this.diary = {} as IDiary;
    this.diary.assignedTo = this.defaultUser;
  }

  cancelButtonPressed(event: MouseEvent)
  {
    this.diary = {} as IDiary;
    this.diary.assignedTo = this.defaultUser;
    this.cancelled.emit();
  }

  allowSave() : boolean
  {
    return (this.diary.dueDate != null) && (this.diary.assignedTo != null) && (this.diary.subject ?? '') != '' && (this.diary.body ?? '') != '';
  }
}
